











































import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Action, namespace } from 'vuex-class';

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";
import mixinsString from "@/mixins/string-mixins";

/**
 * API
 */
import authenticationAPI from '@/api/authentication';

/**
 * Types
 */
import { PrepareActivateAccountRequest } from '@/api/authentication';
import { SettingsResponseModel } from '@/api/settings';

/**
 * VueX Modules
 */
const clientSettingsModule = namespace('settings');

/**
 * Page d'activation de compte (préparation).
 */
@Component({ mixins: [mixinsAPI, mixinsString] })
export default class PrepareActivateAccountPage extends Vue {
	/** VueX - Settings */
	@clientSettingsModule.Getter
	settings!: SettingsResponseModel;

	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' }) openInfo: any;
	@Action('openError', { namespace: 'snackbar' }) openError: any;

	/** Attributs */
	isLoading = false;
	form = new PrepareActivateAccountRequest();

	/** Méthodes */
	async handleSubmit() {
		this.isLoading = true;
		try {
			await authenticationAPI.prepareActivateAccount(this.form);
			this.openInfo(this.$t('users.snackbar_email_account_activation_sent'));
			this.$router.push(`/`);
		}
		catch (err) {
			(this as any).handleAPIError(err);

		}
		this.isLoading = false;
	}

	cancel() {
		this.$router.push(`/`);
	}
}
